import React, { createContext, useContext } from 'react';

/**
 * DESIGN PASS 17 — a card's series marker is DERIVED, never stored. It comes
 * from the card's band and its position inside that band, so moving a card
 * renumbers both bands on the spot.
 */
const SeriesContext = createContext({});

export const SeriesProvider = SeriesContext.Provider;

export function useSeries(cardId) {
  return useContext(SeriesContext)[cardId] || '';
}

/** bands: { cardId: 'A' }, positions: { cardId: {x, y} } for the live breakpoint. */
export function buildSeriesMap(bands, positions, bandKeys = ['A', 'B', 'C', 'D']) {
  const out = {};
  for (const key of bandKeys) {
    const ids = Object.keys(bands || {}).filter((id) => bands[id] === key && positions[id]);
    ids.sort((a, b) => (positions[a].y - positions[b].y) || (positions[a].x - positions[b].x));
    ids.forEach((id, i) => { out[id] = `${key}.${i + 1}`; });
  }
  return out;
}

/** The marker itself, safe to use inside a render callback. */
export function Series({ id }) {
  return <>{useContext(SeriesContext)[id] || ''}</>;
}

export default SeriesContext;
